module.exports = __webpack_public_path__ + "assets/remove.b6f741ed.svg";